import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cUserDtl from './cUserDtl';

class iUserDtl extends cUserDtl {

  $id_stgs ={
    b_useCm11: true,
    b_useCm12: false,
  }

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stss = {
    s_cm1ii110: '', // ドリンク番号
  };

  $ilp_loads = () => [
    ip.$ip_hlr_cm1i({
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
//      cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
      cnd: bf.q(`
        [_KEY]={}
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      )),
    }),
  ];

  $ilp_upds = () => [
    ip.$ip_hlr_cm1i({
      mode: 'ups',
//      cm10_key: global.c?.state.sgcd_pagePntKeys.cm10_key,
      cnd: bf.q(`
        [_KEY]={}
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      )),
    }),
  ];

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('利用者情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10i110',
              pfx:'メール',
              b_mln:false,
/*
              o_stlVal: _s => {
                return bf.myCM_cnv('lwr', _s.val)
              },
*/
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10c310',
              pfx:'氏名',
              b_mln:false,
            },
/*
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm1ii110',
              pfx:'会社名',
              b_mln:false,
            },
*/
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm1ii210',
              pfx:'役職',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm1ii310',
              pfx:'職種',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm11i210',
              pfx:'生年月日（YYYY-MM-DD）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm11i220',
              pfx:'年齢',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm11i310',
              pfx:'性別',
//              ld_itemss: [
              ld_iss: [
                {key:'10', pfx: '男性'},
                {key:'20', pfx: '女性'},
              ],
              b_setValOnChg:false,
            },
            {
              type:'Pck',
              b_vsb:(global.c?.state.sgc_cm10_key == -1 || bf.i(global.c?.state.sgc_cm10c410, ['80','90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10c410',
              pfx:'利用区分',
/*
              ld_iss: [
                {key:'10', pfx: '部門運営者・一般利用者'},
                {key:'20', pfx: '全社運営者'},
                {key:'90', pfx: '全体管理者'},
              ],
*/
              ld_iss: 
                (global.c?.state.sgc_cm10c410 == '90') ?
                  [
                    {key:'10', pfx: '部門運営者・一般利用者'},
                    {key:'20', pfx: '全社運営者'},
                    {key:'90', pfx: '全体管理者'},
                  ]
                : (global.c?.state.sgc_cm10c410 == '80') ?
                  [
                    {key:'10', pfx: '部門運営者・一般利用者'},
                    {key:'20', pfx: '全社運営者'},
                  ]
                : null
              ,
              b_setValOnChg:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10cw10',
              pfx:'利用者ID',
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10cx10',
              ini: '10',
              pfx:'表示順　※全社運営者のみ表示',
            },
/*
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10cz10',
              ini: '10',
              pfx:'削除区分　※全社運営者のみ表示',
              ld_iss: [
                {key:'10', pfx: '削除しない'},
                {key:'0', pfx: '削除する'},
              ],
            },
*/
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm10cz10',
              ini: '10',
              pfx:'表示区分　※全社運営者のみ表示',
              ld_iss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
            },
          ],
        }}
      />
    );
  };
};

export default iUserDtl;
